import { createComponentHealth } from '@shared/components/ComponentHealth';

export const [wrapWithCreateWeddingFormHealthProvider, useCreateWeddingFormHealth] = createComponentHealth('CreateWedding | CreateWeddingForm');
